import { useUser } from "@clerk/clerk-react";
import { Box } from "@chakra-ui/react";
import EditVideoRecommendations from "./components/EditVideoRecommendations";
import VideoEditList from "./components/VideosEditList";
import AddVideoForm from "./components/addVideoForm";
import AdminNavbar from "../../../../components/navbars/adminNavbar/adminNavbar";
import EditHomeVideos from "./components/EditHomeVideos";

export const VideosPanel = () => {
  const { user, isLoaded, isSignedIn } = useUser();

  return (
    <Box>
      {isLoaded && isSignedIn && user?.id && (
        <Box>
          <AdminNavbar />
          <Box p={6}>
            <AddVideoForm clerkId={user.id} />
            <VideoEditList clerkId={user.id} />
            <EditVideoRecommendations clerkId={user.id} />
            <EditHomeVideos clerkId={user.id} />
          </Box>
        </Box>
      )}
    </Box>
  );
};
